// src/hooks/useTheme.ts
import { useUserPreferencesStore } from '@/store/userPreferencesStore';
import type { ThemeMode } from '@/types/appearance';

export type Theme = ThemeMode;

export function useTheme() {
  const theme = useUserPreferencesStore((state) => state.appearancePreferences.themeMode);
  const setAppearancePreferences = useUserPreferencesStore((state) => state.setAppearancePreferences);

  const setTheme = (newTheme: Theme) => {
    setAppearancePreferences({ themeMode: newTheme });
  };

  return { theme, setTheme };
}
